module.exports = __webpack_public_path__ + "static/media/canvas_breakpoint_styles.128fcc44.mp4";